<script>
    import { navigate } from "svelte-navigator"

    import { model, pageNumber } from '../stores';
    import { validator } from '../validation';
    import { getTealiumID, processNextTealiumTags, processPreviousTealiumTags } from '../tealium';
    
    import PrimaryButton from './buttons/PrimaryButton.svelte';
    import PreviousButton from './buttons/PreviousButton.svelte';

    export let onSubmit = () => { };
    export let validate = null;
    export let persistUrl = "";
    export let showPrevious = true;
    export let showNext = true;
    export let previousPage = "";
    export let nextPage = "";
    export let previousPageLabel = "Previous";
    export let nextPageLabel = "Next";
    export let disablePrevious = false;
    export let disableNext = false;

    let basePath = window.basePath || "/";

    const basepath = (basePath.lastIndexOf('/') != basePath.length - 1) ? (basePath + '/') : basePath;

    let nextSpinnerClassName = null;
    let nextBtnDisabled = null;
    let previousBtnDisabled = null;

    const navigatePrevious = function () {
        console.log("Navigating Previous Page to:", previousPage)
        navigate(previousPage);

        try {
            processPreviousTealiumTags(previousPage, $pageNumber);
        } catch {}
    }

    const isFormValid = function () {
        var validationScope = document.querySelector('form');

        if (validationScope === null) return [];

        return $validator.validateAll(validationScope);
    };

    const navigateNextAndPersistData = async function () {
        if (!persistUrl && validate === null) {
            navigateNext();
            return;
        }

        blockNavigationInput();

        //  Get the Tealium Id
        $model.tealiumId = $model.tealiumId || getTealiumID();

        var errors = isFormValid()
        if (errors.length === 0) {
            if (persistUrl) {
                var status = await model.persistJson(basepath + persistUrl);
                if (status) {
                    onSubmit();
                    navigateNext();
                }
            } else {
                navigateNext();
            }
        } else if (errors.length && errors.length > 0) {
            errors[0].scrollIntoView({ behavior: "smooth" });
        }

        unBlockNavigationInput();
    }

    const navigateNext = () => {
        navigate(nextPage);
        console.log("Navigating Next Page to:", nextPage)

        window.scrollTo({ top: 0, behavior: 'smooth' });

        try {
            processNextTealiumTags(nextPage, $pageNumber, nextPage == 'ThankYou');
        } catch {}
    }

    const unBlockNavigationInput = () => {
        nextSpinnerClassName = null;
        nextBtnDisabled = null;
        previousBtnDisabled = null;
    }

    const blockNavigationInput = () => {
        nextSpinnerClassName = "spinner-border spinner-border-sm";
        nextBtnDisabled = true;
        previousBtnDisabled = true;
    }

</script>

{#if !$model.surveyComplete}
    <div class="btn-wrap" class:single="{ showPrevious || showNext }">

        {#if showPrevious }
        <div class="me-2">
            <PreviousButton class="btn btn-primary btn-page-nav {$$props.class}" disabled="{disablePrevious || previousBtnDisabled}" on:click="{() => { navigatePrevious(); }}">
                {previousPageLabel}
            </PreviousButton>
        </div>
        {/if}

        {#if showNext }
        <div>
            <PrimaryButton class="btn btn-primary btn-page-nav {$$props.class}" type="submit" disabled="{disableNext || nextBtnDisabled}" on:click="{() => { navigateNextAndPersistData(); }}">
                <span class="{nextSpinnerClassName}" role="status" aria-hidden="true"></span>
                {nextPageLabel}
            </PrimaryButton>
        </div>
        {/if}
    </div>
{/if}

<style>

    .btn-wrap {
        display: flex;
        justify-content: center;
    }

        .btn-wrap .btn {
            width: 48%;
        }

        .btn-wrap.single {
            display: flex;
            justify-content: center;
        }

    :global(.btn-page-nav) {
        min-width: 240px;
        text-align: left;
    }

    .btn-wrap.single .btn {
        width: 100%;
    }

    @media (min-width:768px) {

            .btn-wrap .btn {
                width: auto;
            }

            .btn-wrap.single .btn {
                width: auto;
            }
    }
</style>
